export default "__VITE_ASSET__CV5UrAEv__"